import styled from 'styled-components';

import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export const SharingEntry = styled.div((p) => ({
  backgroundColor: theme.color.white100,
  padding: pxToRem(24),
  borderRadius: pxToRem(8),
  border: `${pxToRem(1)} solid ${theme.color.purple10}`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  [p.theme.mobileQuery]: {
    padding: pxToRem(24),
    flexDirection: 'row',
    '> *': {
      width: '100%',
    },
  },
}));

export const RewardContainer = styled.div((p) => ({
  height: pxToRem(40),
  width: pxToRem(40),
  borderRadius: pxToRem(8),
  backgroundColor: theme.color.purpleTrans5,
  color: theme.color.orange100,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
